import { Form, TextArea } from 'semantic-ui-react';

import { HEALTH_INFORMATION_MAX_LENGTH } from '../../../utils/registration';
import { useRegistrationText } from './registrationText';

/**
 * Health information the person chose to share — one free-text box, up to 1000 characters.
 *
 * **Who sees it afterwards is narrower than who types it.** Admins and social workers can read it
 * on the profile; centre managers, who enter it here at intake, cannot (owner, 2026-11-03). The
 * hint says so, so nobody is surprised when it is not on the profile they just created.
 */
export const HealthSection = ({
    value,
    onChange,
}: {
    value: string;
    onChange: (next: string) => void;
}) => {
    const t = useRegistrationText();
    return (
    <div className="creator-section">
        <div className="creator-section-title">{t.healthTitle}</div>
        <p className="creator-section-hint">{t.healthHint}</p>
        <Form.Field>
            <label htmlFor="health-information">{t.healthLabel}</label>
            <TextArea
                id="health-information"
                rows={5}
                maxLength={HEALTH_INFORMATION_MAX_LENGTH}
                value={value}
                onChange={(_, d) => onChange(String(d.value ?? ''))}
            />
            <div className="field-counter">{value.length} / {HEALTH_INFORMATION_MAX_LENGTH}</div>
        </Form.Field>
    </div>
);
};
